import { fillString } from '@local_modules/generic/string-template.js'
import { addListeners } from './listeners.js'
import htmlUserShowOne from './user-list-one.html'
import htmlUserSupport from './user-list-support.html'
import { setElementHtml } from '../../../../helpers/generic-js/dom.js'

const containerElementId = 'userList'

export async function showUserList (params) {
  console.log('showUserList', params)
  const { browserAppAccount, browserAppUser } = params

  const containerElement = setElementHtml(containerElementId, '')
  console.log('containerElement', containerElement)

  const appAccountUsers = browserAppAccount.data?.appAccount?.AppUserAccounts?.map(function (oneAppUserAccount) {
    return {
      user: oneAppUserAccount.app_user,
      app_user_id: oneAppUserAccount.app_user_id,
      rights: oneAppUserAccount.rights
    }
  })

  appAccountUsers?.forEach(function (oneAccountUser) {
    console.log('oneAccountUser', oneAccountUser)

    // Do not show the invitations here
    if (!oneAccountUser.user) return

    const userElement = showOneUser(oneAccountUser, browserAppUser)
    containerElement?.insertAdjacentHTML('beforeend', userElement)
  })

  addListeners(containerElement)
}

/**
 *
 * @param {*} oneAccountUser
 * @returns
 */
function showOneUser (oneAccountUser, browserAppUser) {
  console.log('showOneUser', oneAccountUser, browserAppUser)

  if (oneAccountUser.isSupport) {
    return htmlUserSupport
  }

  const isCurrentUser = oneAccountUser.app_user_id === browserAppUser?.data?.appUser?.id

  const disableButton = fillString('<div class="button is-small is-warning" data-action="disable" data-user-id=":userId" data-invite-id=":inviteId">Disable</div>', {
    userId: oneAccountUser.app_user_id
    // TODO inviteId: oneAccountUser?._id
  })

  // If current user, do not show the disable button
  return fillString(htmlUserShowOne, {
    userEmail: oneAccountUser.user?.email || '',
    userName: oneAccountUser.user?.name,
    userRights: oneAccountUser.rights.map(function (oneRight) {
      return '<span class="tag is-info is-light">' + oneRight + '</span>'
    }).join(''),
    tagCurrentUser: isCurrentUser ? '<span class="tag is-info ">This is you</span>' : '',
    disableButton: isCurrentUser ? '' : disableButton
  })
}
